import type { SocialPlatform, ScheduledPostStatus } from "@content-os/config";

export const PLATFORM_COLORS: Record<SocialPlatform, string> = {
  INSTAGRAM: "#E4405F",
  TIKTOK: "#000000",
  FACEBOOK: "#1877F2",
  YOUTUBE: "#FF0000",
  LINKEDIN: "#0A66C2",
  TWITTER: "#1DA1F2",
  THREADS: "#000000",
  PINTEREST: "#E60023",
  REDDIT: "#FF4500",
  GOOGLEBUSINESS: "#4285F4",
};

export const STATUS_COLORS: Record<ScheduledPostStatus, string> = {
  SCHEDULED: "#3B82F6",
  PUBLISHED: "#22C55E",
  FAILED: "#EF4444",
  CANCELLED: "#6B7280",
};

export const STATUS_LABELS: Record<ScheduledPostStatus, string> = {
  SCHEDULED: "Scheduled",
  PUBLISHED: "Published",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
};

export function getPlatformColor(platform: SocialPlatform): string {
  return PLATFORM_COLORS[platform] ?? "#6B7280";
}

export function getStatusColor(status: ScheduledPostStatus): string {
  return STATUS_COLORS[status] ?? "#6B7280";
}
